import React, { Component } from 'react';
import t from 'rcm-i18n';
import QuantitySelector from './lib/QuantitySelector';
import type PotentialOrderLine from './PotentialOrderLine';
import type SkuLine from './SkuLine';
import useVatCalculator from '../../block-all-products/src/useVatCalculator';

interface Props {
  skuLine: SkuLine;
  potentialOrderLine: PotentialOrderLine;
  onQuantityChange: (skuLine: SkuLine, newQuantity: number) => void;
  showBvPv: boolean;
  skuNumber: string;
  showVat: boolean;
}

const SkuSectionSkuLineComponent = ({
  skuLine,
  potentialOrderLine,
  onQuantityChange,
  showBvPv,
  skuNumber,
  showVat,
}: Props) => {
  const combinedPrice = useVatCalculator(
    skuLine.formattedPrice,
    skuLine.data?.vatAmount || 0
  );

  const handleQuantityChange = (newQuantity: number) => {
    onQuantityChange(skuLine, newQuantity);
  };

  return (
    <tr className='SkuSectionSkuLineComponent'>
      <td className='SkuSectionSkuLineComponent-ImageWrap hidden-xs'>
        {skuLine.mainImage && <img src={skuLine.mainImage.imageSrc} />}
      </td>
      <td>
        <div>
          <a href={skuLine.detailPageUrl}>{skuLine.name}</a>
        </div>
        {skuLine.data && skuLine.data.isBackOrdered && (
          <div className='SkuSectionSkuLineComponent-lineItemWarning'>
            {t('This item is backordered.')}
          </div>
        )}
        {skuLine.data && skuLine.data.isAvailableForPurchase === false && (
          <div className='SkuSectionSkuLineComponent-lineItemWarning'>
            {t('This item is temporarily out of stock due to high demand and will be back in stock soon.')}
          </div>
        )}
        {skuLine.data &&
          parseInt(skuLine.data.maxQuantityAllowedPerOrder) > 0 &&
          potentialOrderLine.quantity >
            parseInt(skuLine.data.maxQuantityAllowedPerOrder) && (
            <div className='alert alert-warning'>
              {t(
                'The maximum quantity allowed per order for individual items of {productName} is {maxQty}. Please order cases instead.',
                {
                  maxQty: skuLine.data.maxQuantityAllowedPerOrder,
                  productName: skuLine.name,
                }
              )}
            </div>
          )}
      </td>
      {/*<td className="hidden-xs">{skuLine.skuNumber}</td>*/}
      {showBvPv && <td className='hidden-xs'>{skuLine.formattedBv}</td>}
      {showBvPv && <td className='hidden-xs'>{skuLine.formattedPv}</td>}
      <td className='vat-price'>{skuLine.formattedPrice}</td>
      {showVat && <td className='hidden-xs vat-price'>{combinedPrice}</td>}

      <td>
        <QuantitySelector
          value={potentialOrderLine.quantity}
          onValueChange={handleQuantityChange}
          max={200}
          skuNumber={skuNumber}
        />
      </td>
      <td className='hidden-xs'>{potentialOrderLine.formattedLineTotal}</td>
    </tr>
  );
};

export default SkuSectionSkuLineComponent;
